<div class="bounds" #myBounds
    [ngClass]="{ 'top-b': !edge?.top, 'bottom-b': !edge?.bottom, 'left-b': !edge?.left, 'right-b': !edge?.right }">
    <div class="fx_modal-options fx_modal_container" ngDraggable [bounds]="myBounds" (edge)="checkEdge($event)" [inBounds]="inBounds"
        [handle]="myHandle" #layout>
        <!-- 标题栏 -->
        <div class="fx_modal_title" #myHandle>
            <div class="fx_le_title">
                <i class="anticon anticon-credit-card"></i>
                <span>{{title}}</span>
            </div>
            <div class="fx_ri_title">
                <i class="anticon anticon-arrows-alt fullBtn" title="{{isFull ? ('comm-缩小' | translate) : ('comm-放大' | translate)}}" (click)="fullModal(isParm)"
                    [ngClass]="{'anticon-shrink': isFull}"></i>
                <i style="margin-left: 16px;" class="anticon anticon-close fx_modal_close_btn" title="{{'comm-关闭' | translate}}" (click)="fxCloseModal()"></i>
            </div>
        </div>
        <!-- 显示区域 -->
        <dw-row class="fx_modal_content" [style.height]="isHeight">
            <div dw-row dwType="flex" dwJustify="end">
                <dw-col dwSpan="24">
                    <!-- <span>{{'com-选配' | translate}}：{{dataInfo.model_no}} -->
                        <span>{{dataInfo.model_no}}
                        {{dataInfo.model_name ? ('(' + dataInfo.model_name + ')') : ''}}</span>
                </dw-col>
            </div>

            <div class="fx_goods_ct_options" *ngFor="let chcar of optionTypeList;let key=index;">
                <span>{{chcar.cad002_n1}}</span>
                <ul>
                    <li *ngFor="let item of chcar.cae_f_list_unique;let valKey=index;"
                        [ngClass]="{'option-select': item.selected, 'option-disabled': item.disabled}"
                        (click)="selectOptionAndFixing(key, valKey)">
                        {{item.cae003_n1}}</li>
                </ul>
            </div>
            <div *ngIf="!optionTypeList.length && isReady" class="fx-option-emtpy">
                <span>暂无数据~</span>                
            </div>
        </dw-row>

        <dw-row class="fx_modal_footer">
            <div dw-col [dwSpan]="24">
                <div dw-row dwType="flex" dwJustify="end">
                    <button *ngIf="isCreateAllBtnShow" dw-button [dwType]="'primary'" (click)="onClickOK('all')">全部产生</button>
                    <button dw-button [dwType]="'default'" (click)="onClickCancel()">取消</button>
                    <button dw-button [dwType]="'primary'" (click)="onClickOK()">确定</button>
                </div>
            </div>
        </dw-row>
    </div>

</div>